import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface DeptAdminRouteProps {
  children: React.ReactNode;
}

export function DeptAdminRoute({ children }: DeptAdminRouteProps) {
  const { user, profile, loading, profileReady, isDeptAdmin, isOrgAdmin, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading || !profileReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isDeptAdmin && !isOrgAdmin && !isSuperAdmin && profile?.role !== 'dept_admin') {
    return <Navigate to="/assessment/start" replace />;
  }

  // Must have a department assigned (unless org_admin or superadmin)
  if (!profile?.departmentId && !isOrgAdmin && !isSuperAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Ingen avdeling tilknyttet
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Din konto er ikke tilknyttet noen avdeling. Kontakt administrator.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}




